<div class="p-3">
  <div class="row mb-3">
    <div class="col-12 d-flex align-items-center">
      <label class="mb-0">Tope de histórico hacia atrás por periodo</label>
      <div class="ms-auto d-flex acciones">
        <button mat-raised-button color="warn" (click)="borrarDatosMetaApi()" [disabled]="isLoading || isBorrando"
                matTooltip="Borra todas las velas de MetaAPI para que se vuelvan a descargar desde cero">
          <mat-icon>delete_forever</mat-icon>
          Borrar datos MetaAPI
        </button>
        <button mat-raised-button (click)="cargar()" [disabled]="isLoading">
          <mat-icon>refresh</mat-icon>
          Recargar
        </button>
        <button mat-raised-button color="primary" (click)="guardar()" [disabled]="isLoading || !hayCambios || !todoValido">
          <mat-icon>save</mat-icon>
          Guardar
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading || isBorrando" class="mb-3">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <table mat-table [dataSource]="filas" class="w-100 periodos-table" *ngIf="filas.length">
    <ng-container matColumnDef="grupoPeriodo">
      <th mat-header-cell *matHeaderCellDef></th>
    </ng-container>

    <ng-container matColumnDef="periodo">
      <th mat-header-cell *matHeaderCellDef>Periodo</th>
      <td mat-cell *matCellDef="let fila">
        {{ etiqueta(fila.timeframe) }} <span class="text-muted">({{ fila.timeframe }})</span>
        <mat-icon *ngIf="tieneCambios(fila)" class="cambio-icon" matTooltip="Sin guardar">edit</mat-icon>
      </td>
    </ng-container>

    <ng-container *ngFor="let f of fuentes">
      <ng-container [matColumnDef]="'grupo-' + f.clave">
        <th mat-header-cell *matHeaderCellDef [attr.colspan]="3" class="grupo-fuente">{{ f.etiqueta }}</th>
      </ng-container>

      <ng-container [matColumnDef]="f.clave + 'Cantidad'">
        <th mat-header-cell *matHeaderCellDef class="inicio-fuente">Cantidad</th>
        <td mat-cell *matCellDef="let fila" class="inicio-fuente">
          <ng-container *ngIf="fila[f.clave] as tope; else noAplica">
            <mat-form-field class="cantidad-field" subscriptSizing="dynamic">
              <input matInput type="number" min="1" [max]="maximo(tope)" step="1"
                     [(ngModel)]="tope.cantidad" [disabled]="isLoading">
            </mat-form-field>
            <div *ngIf="!esValido(tope)" class="text-danger small">Entre 1 y {{ maximo(tope) }}</div>
          </ng-container>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="f.clave + 'Unidad'">
        <th mat-header-cell *matHeaderCellDef>Unidad</th>
        <td mat-cell *matCellDef="let fila">
          <mat-form-field *ngIf="fila[f.clave] as tope" class="unidad-field" subscriptSizing="dynamic">
            <mat-select [(ngModel)]="tope.unidad" [disabled]="isLoading">
              <mat-option *ngFor="let u of unidades" [value]="u.valor">{{ u.etiqueta }}</mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="f.clave + 'Desde'">
        <th mat-header-cell *matHeaderCellDef>Desde (hoy)</th>
        <td mat-cell *matCellDef="let fila">
          <ng-container *ngIf="fila[f.clave]">{{ (desde(fila[f.clave]) | date:'yyyy-MM-dd') || '-' }}</ng-container>
        </td>
      </ng-container>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnasGrupo"></tr>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <ng-template #noAplica>
    <span class="text-muted small" matTooltip="Esta fuente no usa el tope en este periodo">No aplica</span>
  </ng-template>

  <div *ngIf="!isLoading && !filas.length" class="text-muted">
    No hay periodos configurados.
  </div>
</div>
